import { createFileRoute, Outlet } from '@tanstack/react-router';
import OutlookTaskpaneLayout from 'src/features/plugins/outlook/taskpane/layout';

export const Route = createFileRoute('/plugins/outlook/taskpane')({
  component: () => (
    <OutlookTaskpaneLayout>
      <Outlet />
    </OutlookTaskpaneLayout>
  ),
});
